<template>
  <div>
    <div class="modal-bg" v-if="savedBankPage.src">
      <vue-friendly-iframe :src="savedBankPage.src" v-if="savedBankPage.src" class="text-center"></vue-friendly-iframe>
    </div>
    <div class="modal-bg" v-if="bankPage.src">
      <vue-friendly-iframe :src="bankPage.src" v-if="bankPage.src" class="text-center"></vue-friendly-iframe>
    </div>

    <!-- SELECT NO OF SEAT SECTION -->
    <section v-if="sectionName.noOfSeats">
      <!-- Add dynamic style url -->
      <div class="banner"></div>
      <div class="select-seat-section" v-if="sectionName.noOfSeats">
        <div class="container px-2 px-md-3">
          <div class="select-seat-container">
            <div>
              <!-- <h6>Please select the number of seats</h6> -->
              <ul class="select-seat-list">
                <li v-for="(number, index) in numberofSeatsArray" :key="index">
                  <span v-if="number == totalNumberOfSeats" class="selected"
                    v-on:click="editNumberOfSeats(number)">{{number}}</span>
                  <span v-else v-on:click="editNumberOfSeats(number)">{{number}}</span>
                </li>
              </ul>
              <!-- <button v-on:click="confirmNumber()" class="btn-confirm">CONFIRM</button> -->
            </div>
          </div>
        </div>
      </div>

      <div class="checkoutDetails-container">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-11 mx-auto">
          <div class="row">
            <div class="col-10">
              <div class="row">
                <div class="col-8 col-md-auto mb-2 mb-md-0">
                  <div class="font-weight-bold">{{movieDetails.title}}</div>
                  <div class="title">
                    <span>{{movieDetails.lang}}</span>
                    <!-- <span>|</span> -->
                    <!-- <span>2D</span> -->
                    <span>|</span>
                    <span>{{movieDetails.runTime}}</span>
                  </div>
                </div>

                <div class="col-4 col-md col-lg-2 mb-2 mb-md-0 px-0 px-md-3">
                  <div class="title">Show Time</div>
                  <div>10:00 Am</div>
                </div>

                <div class="col-8 col-md col-lg-2">
                  <div class="title">Show Date</div>
                  <div>28 Mar 2019</div>
                </div>

                <div class="col-4 col-md col-lg-2 px-0 px-md-3">
                  <div class="title">Venueaaa</div>
                  <div>Dubai Mall</div>
                </div>
              </div>
            </div>

            <div class="col-2 d-flex align-items-center justify-content-end">
              <div class="d-flex align-items-center">
                <div v-on:click="confirmNumber()" class="pr-3 d-none d-md-block">Proceed</div>
                <button class="btn-chevron-right float-right" title="Proceed"></button>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>

    <!-- SELECT SEAT LAYOUT SECTION -->
    <section v-if="sectionName.seatLayout">
      <div class="select-seat-section">
        <div class="banner"></div>
        <div class="container px-2 px-md-3">
          <div class="select-seat-container">
            <div style="overflow:auto;">
              <table class="seat-layout-table">
                <tbody>
                  <tr>
                    <td colspan="50">
                      <div class="screen"></div>
                    </td>
                  </tr>
                  
                  <div class="mx-auto text-center"  v-if="totalNumberOfSeats > 0" v-for="(singleSeatLayout, seatTypeIndex) in seatLayout" :key="seatTypeIndex" >
                      <div class="mt-4 mb-2 seat-formatTxt" v-if="singleSeatLayout.Seats.length > 0 && singleSeatLayout.Seats[0].length > 0 && singleSeatLayout.Seats[0][0].hasOwnProperty('SeatClassID')">
                       <div class="seat-catg screen-class" style="height: 21px; margin-top: 10px;text-transform: uppercase;">{{ singleSeatLayout.SeatClass.filter((x)=> { return singleSeatLayout.Seats[0][0].SeatClassID == x.SeatClassID })[0].Label }}&nbsp; CLASS</div>
                       </div>
                      <table class="mx-auto seat-table">
                        <!-- {{ seatTypes[seatTypeIndex].Label }} -->                                               
                        <tr v-for="(seatArray, seatRowIndex) in singleSeatLayout.Seats" :key="seatRowIndex">
                          <td v-for="(seat, singleSeatIndex) in seatArray" :key="singleSeatIndex"
                               v-if="seat.Status == 1"
                              v-on:click="handlerSeatSelected(seat, seatTypeIndex, seatRowIndex, singleSeatIndex, null, null, $event)"
                              >
                            <div class="seat-available" :class="{ selected : seat.SelectStatusFlag}"></div>
                          </td>
                           <td v-for="(seat, singleSeatIndex) in seatArray" :key="singleSeatIndex" v-if="seat.Status != 1">
                              <div class="seat-unavailable"></div>
                            </td>
                        </tr>
                      </table>
                  </div>




                  <!-- <div v-for="(singleSeatType, seatTypeIndex) in SeatTypes" :key="seatTypeIndex">
                    {{singleSeatType.Label}}
                  <tr v-for="(seatsArray, seatArrayIndex) in seatLayout" :key="seatArrayIndex">
                    <td v-for="(singleSeat, singleSeatIndex) in seatsArray" :key="singleSeatIndex">
                      <div v-if="singleSeat.Status == 1" class="seat-available"
                        v-on:click="handlerSeatSelected(singleSeat, seatArrayIndex, singleSeatIndex, null, null, $event)"
                        v-bind:class="{ selectedSeat : singleSeat.SelectStatusFlag }">{{singleSeat.singleSeat}}</div>

                      <div class="seat-unavailable" v-else-if="singleSeat.Status == 2">{{singleSeat.SeatName}}</div>
                    </td>
                  </tr>
                  </div> -->
                </tbody>
              </table>
              

              <nav class="navigation">
                <ul class="seat-appearance-list">
                  <li>SOLD</li>
                  <li>AVAILABLE</li>
                  <li>SELECTED</li>
                </ul>
                <button class="btn-confirm" v-on:click="onSeatConfirmaton()">
                  <span v-if="selectedSeats.length > 0" v-html="seatData.Currency"></span>
                  CONFIRM SEATS ({{seatData.Currency}}:{{totalAmount}})
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
        <div class="checkoutDetails-container d-none d-md-block">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-11 mx-auto">
          <div class="row">
            <div class="col-10">
              <div class="row">
                <div class="col-8 col-md-auto mb-2 mb-md-0">
                  <div class="font-weight-bold">{{cinemaDetails.MovieTitle}}</div>
                  <div class="title">
                    <span>English</span>
                    <span>|</span>
                    <span>2D</span>
                    <span>|</span>
                    <span>115 Min</span>
                  </div>
                </div>

                <div class="col-4 col-md col-lg-2 mb-2 mb-md-0 px-0 px-md-3">
                  <div class="title">Show Time</div>
                  <div>10:00 Am</div>
                </div>

                <div class="col-8 col-md col-lg-2">
                  <div class="title">Show Date</div>
                  <div>28 Mar 2019</div>
                </div>

                <div class="col-4 col-md col-lg-2 px-0 px-md-3">
                  <div class="title">Venue</div>
                  <div>{{cinemaDetails.Address}}</div>
                </div>
              </div>
            </div>

            <div class="col-2 d-flex align-items-center justify-content-end">
              <div class="d-flex align-items-center">
                <div  class="pr-3 d-none d-md-block">Proceed</div>
                <button v-on:click="onSeatConfirmaton()"  class="btn-chevron-right float-right" title="Proceed"></button>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>

    <!--CHECKOUT FINAL PAGE-->
    <section v-if="sectionName.checkout">
      <div class="selected-show-container">
        <div class="container-fluid">
          <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
            <div class="row">
              <div class="col-md-8 order-2 order-md-1">
                <div class="section-contact" v-if="modal.signIn">
                  <h6>Share your Contact Details</h6>
                  <div>
                    <form @submit.prevent="validateBeforeSubmit('bookUser')" data-vv-scope="bookUser">
                      <div class="form-row">
                        <div class="col-md-6 col-xl-5 mb-3 mb-md-0">
                          <input type="text" class="form-control" placeholder="Email" v-model="userDetails.email">
                        </div>
                        <div class="col-md-6 col-xl-5 mb-3 mb-md-0">
                          <input type="number" class="form-control" placeholder="Contact number"
                            v-model="userDetails.phoneNumber">
                        </div>
                        <div class="col-12 col-xl-2">
                          <input type="submit" value="CONTINUE" class="btn-confirm">
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="section-login" v-if="modal.userTicketsDetails">
                  <div class="row">
                    <div class="col-md-10 mb-3 mb-md-0">
                      <h6>Your tickets will be sent to {{userDetails.email}} & {{userDetails.phoneNumber}}</h6>
                    </div>
                    <div class="col-md-2 pl-md-0">
                      <button class="btn-confirm w-100" v-on:click="editDetails()">Edit</button>
                    </div>
                  </div>
                </div>

                <div class="section-login" v-if="modal.payUsingWallet">
                  <div class="row">
                    <div class="col-md-10 mb-3 mb-md-0">
                      <h6>Please Login to use My Wallet</h6>
                    </div>
                    <div class="col-md-2 pl-md-0">
                      <button class="btn-confirm w-100" v-b-modal.signIn>Login</button>
                    </div>
                  </div>
                </div>

                <div v-if="modal.payment" class="section-offers">
                  <h6 v-b-toggle.offer-promo>Unlock Offers or Apply Promo Code</h6>
                  <b-collapse id="offer-promo">
                    <div class="row pt-4">
                      <div class="col-md-5">
                        <h6 class="mb-2">Debit & Credit Card Offer</h6>
                        <select class="form-control">
                          <option v-for="(promo, promokey) in promoCode.promoList" :key="promokey">{{promo.Description
                            }}</option>
                          <!-- <option>Offer 2</option>
                          <option>Offer 3</option> -->
                        </select>
                      </div>
                      <div class="col-md-1 d-flex justify-content-center align-items-center">OR</div>
                      <div class="col-md">
                        <h6 class="mb-2">Enter Promo Code</h6>
                        <form>
                          <div class="form-row">
                            <div class="col-8">
                              <input type="text" placeholder="Enter Promo Code" class="form-control">
                            </div>
                            <div class="col-4">
                              <input type="submit" class="btn-confirm h-100">
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </b-collapse>
                </div>

                <div v-if="modal.payment" class="section-payment">
                  <h6>Select Payment Mode</h6>

                  <b-tabs pills vertical nav-wrapper-class="col-md-3 col-xl-2">
                    <b-tab title="ExpressPay" active>
                      <div class="mb-3">
                        Pay Using
                        <span class="font-weight-bold">ExpressPay</span>
                      </div>

                      <!-- ADD CLASS CARD-SELECTED ON SELECTING FROM CARD -->
                      <div class="saved-card">
                        <div>
                          <div class="h6">Axis Bank</div>
                          <div>1234 XXXX XXXX XXXX</div>
                        </div>
                        <div class="d-md-flex align-items-center">
                          <label class="mr-3 mb-0 small" for="cvv">CVV</label>
                          <input placeholder="123" type="number" class="form-control" id="cvv">
                        </div>
                      </div>

                      <div class="saved-card card-selected">
                        <div>
                          <div class="h6">Axis Bank</div>
                          <div>1234 XXXX XXXX XXXX</div>
                        </div>
                        <div class="d-md-flex align-items-center">
                          <label class="mr-3 mb-0 small" for="cvv">CVV</label>
                          <input placeholder="123" type="number" class="form-control" id="cvv">
                        </div>
                      </div>

                      <button class="btn-confirm mb-3">Proceed</button>

                      <div class="text-muted">You do not have ant saved Credit/Debit card</div>
                    </b-tab>

                    <!-- <b-tab title="My Wallet">
                      <div class="mb-3">
                        Pay Using
                        <span class="font-weight-bold">My Wallet</span>
                      </div>

                      <div class="mb-4">Available balance in your Wallet <span
                          class="font-weight-bold text-italic">$1999</span></div>
                      <form class="mb-3 pl-1">
                        <label for="otp">Please Enter OTP sent on your Registered Mobile Number</label>
                        <input type="text" id="otp" placeholder="OTP" class="form-control" style="width:58px;">
                      </form>


                      <button class="btn-confirm d-block">Proceed</button>
                    </b-tab> -->


                     <!-- <b-tab title="My Wallet">
                      <div class="mb-3">
                        Pay Using
                        <span class="font-weight-bold">My Wallet</span>
                      </div>
                       <div class="mb-4">Available balance in your Wallet <span
                          class="font-weight-bold text-italic">$1999</span></div>
                      <button @click="processPayment()" v-if="!showOTP" v-on:click="showOTP = true" class="btn-confirm d-block">Continue</button>  

                      <div v-if="showOTP">
                     
                      <form class="mb-3 pl-1">
                        <label for="otp">Please Enter OTP sent on your Registered Mobile Number</label>
                        <input type="text" id="otp" v-model="OTP" placeholder="OTP" class="form-control" style="width:58px;">
                      </form>


                      <button class="btn-confirm d-block">Proceed</button>
                      </div>                
                    </b-tab> -->

                      <b-tab v-if="singlePayment.PaymentID == 1" v-for="(singlePayment, paymentKey) in newPaymentOptions" :key="paymentKey" title="My Wallet">
                      <div class="mb-3">
                        Pay Using
                        <span class="font-weight-bold">My Wallet</span>
                      </div>
                       <div class="mb-4">{{singlePayment.Message}}<span
                          class="font-weight-bold text-italic"></span></div>
                      <button @click="processPayment()" v-if="!showOTP" v-on:click="showOTP = true" class="btn-confirm d-block">Continue</button>  

                      <div v-if="showOTP">
                     
                      <form class="mb-3 pl-1">
                        <label for="otp">Please Enter OTP sent on your Registered Mobile Number</label>
                        <input type="text" id="otp" v-model="OTP" placeholder="OTP" class="form-control" style="width:58px;">
                      </form>


                      <button @click="confirmBooking()" class="btn-confirm d-block">Proceed</button>
                      </div>                
                    </b-tab>

                    <b-tab title="Debit Card">
                      <div>
                        <div class="mb-3">
                          Pay Using
                          <span class="font-weight-bold">Debitcard</span>
                        </div>
                        <div class="card mb-3">
                          <div class="card-title">mastercard</div>
                          <img src="@/assets/img/svg/icon-card.svg" class="mb-3" height="30px" width="30px"
                            alt="icon-card">
                            <form data-vv-scope="cardDetails">
                            <div class="col-md-10 pl-0 mb-4">
                              <label for="card-num">NUMBER</label>
                              <div class="form-row">
                                <div class="col">
                                  <input type="number"
                                    maxlength="4"
                                    pattern="([12345])\w{0}"
                                    v-model="creditCardDetails.number[0]"
                                    ref="card0"
                                    placeholder="1234" id="card-num">
                                </div>
                                <div class="col">
                                  <input type="number" 
                                  maxlength="4"
                                    pattern="([12345])\w{0}"
                                    v-model="creditCardDetails.number[1]"
                                    ref="card1"
                                    placeholder="****">
                                </div>
                                <div class="col">
                                  <input type="number" 
                                  maxlength="4"
                                    pattern="([12345])\w{0}"
                                    v-model="creditCardDetails.number[2]"
                                    ref="card2"
                                  placeholder="****">
                                </div>
                                <div class="col">
                                  <input type="number" 
                                    maxlength="4"
                                    pattern="([12345])\w{0}"
                                    v-model="creditCardDetails.number[3]"
                                    ref="card3"
                                    placeholder="****">
                                </div>
                              </div>
                            </div>

                            <div class="form-row">
                              <div class="col-8 pr-md-4">
                                <label for="card-name">NAME</label>
                                <input v-model="creditCardDetails.name" type="text" placeholder="John Doe">
                              </div>
                              <div class="col-4 col-md-3">
                                <label for="card-name">EXPIRY</label>
                                <div class="form-row">
                                  <div class="col">
                                    <input v-model="creditCardDetails.expiryMonth" type="number">
                                  </div>
                                  <div>
                                    <label for>/</label>
                                  </div>
                                  <div class="col">
                                    <input v-model="creditCardDetails.expiryYear" type="number">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>

                        </div>
                        <button @click="validateBeforeSubmit('cardDetails')" type="submit" class="btn-confirm">Proceed</button>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>

              <div class="col-md-4 order-1 order-md-2">
                <div class="section-selectedShow">
                  <div>
                    <div class="d-flex mb-3">
                      <div class="ticket-icon">
                        <div class="date">2</div>
                        <div>
                          <div>MAR</div>
                          <span>13:00</span>
                        </div>
                      </div>
                      <div class="d-flex flex-column justify-content-between">
                        <div class="text-pink font-weight-bold">{{movieDetails.title}}</div>
                        <div class="small">{{movieDetails.lang}}</div>
                        <div class="small">{{movieDetails.runTime}}</div>
                        <div>{{cinemaDetails.Address}}</div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                      <div>
                        <h6 class="mb-1">SEATS ({{ selectedSeats.length }})</h6>
                        <ul class="selected-seat" v-if="getSeatLayout">
                          <li v-for="(seat, index) in selectedSeats" :key="index">{{seat.SeatName}}</li>
                        </ul>
                      </div>

                      <div>
                        <h6 class="mb-1">SCREEN</h6>
                        <div>Screen 1</div>
                      </div>
                    </div>

                    <div>
                      <h6 class="mb-1">BOOKING</h6>
                      <div class="d-flex justify-content-between">
                        <div>Tickets ({{ selectedSeats.length }})</div>
                        <div>{{totalAmount}}</div>
                      </div>

                      <div class="d-flex justify-content-between border-bottom pb-2">
                        <div>Internet Handling Fees</div>
                        <div>{{internetHandling}}</div>
                      </div>

                      <div class="d-flex justify-content-between py-2 border-bottom">
                        <h6 class="mb-0">Total Amount</h6>
                        <div>{{totalAmount}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FINAL TICKET SECTION -->
    <!-- v-if="sectionName.confirmation" -->
    <section v-if="sectionName.confirmation">
      <div class="ticket-container">
        <div class="container">
          <!-- TICKET STATUS ALERT -->
          <div class="alert alert-success">
            <h5 class="alert-heading">Thank you for your purchase</h5>
            <div>
              You can access your tickets form your profile. We will send you an e-mail & SMS confirmation within 15
              minutes.
            </div>
          </div>
          <!-- ACTUAL TICKET -->
          <div class="confirmation-ticket">
            <div class="row mx-0">
              <div class="col-md-3 p-0 d-none d-md-block">
                <img :src="movieDetails.movie_card_img" class="img-fluid">
              </div>
              <div class="col py-3 d-flex">
                <div class="pr-3 d-md-none">
                  <img :src="movieDetails.movie_card_img" class="img-fluid">
                </div>
                <div>
                  <h5 class="text-pink">{{movieDetails.title}}</h5>
                  <p class="text-muted">{{cinemaDetails.Address}}</p>
                  <h6>
                    2 Mar
                    <span>10:30 Am</span>
                  </h6>
                  <div class="small">SEATS ({{ selectedSeats.length }})</div>
                  <ul class="selected-seat">
                    <li v-for="(seat, index) in selectedSeats" :key="index">{{seat.SeatName}}</li>
                    <!-- <li>F6</li>
                    <li>F6</li>
                    <li>F6</li> -->
                  </ul>
                </div>
              </div>
              <div class="col-md-3 py-3 text-center">
                <img class="img-fluid" src="@/assets/img/qr.png">
                <p>BOOKING ID</p>
                <div>{{bookingID}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- SESSION TIMEOUT  -->
    <div class="modal-bg" v-if="timer.TimeoutModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content rounded">
          <div class="modal-header">
            <h5 class="modal-title text-center" id="exampleModalLongTitle">TIMED OUT</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-light rounded text-center">
            <h1>
              <i class="fas fa-exclamation-triangle text-pink"></i>
            </h1>

            <p>Sorry your session has timed out!</p>

            <p class="text-muted small px-3">
              Sorry, There is a problem with the connectivity at the venue. Please try
              after some time. You could also try calling 022 6144 5050, 022 3989 5050 to book tickets or if the
              problem persists please write to us at helpdesk@ticketak.com
            </p>

            <a v-on:click="restartBooking($event)" class="form-control col-8 btn btn-outline-dark">START AGAIN</a>
          </div>
        </div>
      </div>
    </div>

    <!-- MOVIE CHECKOUT MODAL -->
    <div class="modal-bg" v-if="sectionName.typeSelector">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" class="close text-right px-2" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="col-12 mx-auto">
              <div class="seatPopHdr">
                <div class="row">
                  <div class="col-md-8 col-12 py-md-0 py-5">
                    <div class="seatCol1">
                      <div class="headline pb-4">Select Movie Class Category?</div>
                      <div class="ticktSum">
                        <hr>
                        <div class="seatClass">
                          <div class="fl">
                            <input type="radio" value checked="checked" name="rdbschClass">
                          </div>
                          <p class="seatTitle">
                            Bachelor
                            <span>(3.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input type="radio" value name="rdbschClass">
                          </div>
                          <p class="seatTitle">
                            Family
                            <span>(3.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input id="rdbClass87098" type="radio" value name="rdbschClass">
                          </div>
                          <p class="seatTitle">
                            Premium Bachelor
                            <span>(4.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input id="rdbClass87099" type="radio" value="87099" name="rdbschClass">
                          </div>
                          <p class="seatTitle">
                            Premium Family
                            <span>(4.5 KWD)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="p-3">
                      <a href="#" class="btn btn-info w-75">Book Now</a>
                    </div>
                  </div>

                  <div class="col-4 p-0 d-none d-md-block">
                    <div class="seatCol2" id="divSeatSelMovie">
                      <div class="mvD-img">
                        <img src="img/e0c882f0f59849649fc8a2b392d5baeb.jpg" alt class="img-fluid">
                      </div>
                      <h1>Black Water (15+)</h1>
                      <p class="mvD-type">2D</p>
                      <p class="mvD-type">Action,Drama</p>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">LANGUAGE</p>
                        <p>English</p>
                      </div>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">SUBTITLES</p>
                        <p>English</p>
                      </div>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">LENGTH</p>
                        <p>1h 45min</p>
                      </div>
                      <div class="showTime">
                        <h3>
                          <span class="bold">Cinescape</span> : KNCC Test Site
                        </h3>
                        <p>2018-12-24, 19:15</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { secureStore } from "@/helper/storage";
import { EventBus } from "@/main";
import VueFriendlyIframe from "vue-friendly-iframe";
import { TokenService } from "@/services/storage.service";
import _ from "lodash";
// import VueSnackbar from 'vue-snack'
// Vue.use(VueSnackbar)
Vue.component("vue-friendly-iframe", VueFriendlyIframe);

// import {
//   // mapActions
//   mapGetters
// } from "vuex";

export default {
  head: {
    title() {
      return `Ticketak`;
    },
    meta: [
      {
        name: "description",
        content() {
          return `Here is the description`;
        }
      }
    ]
  },
  //   asyncData({ store, route }) {
  //   },
  data() {
    return {
      showOTP: false,
      bankPage: {
        src: ""
      },
      cinemaDetails: {},
      Default: {},
      showDetails: {},
      savedBankPage: {
        src: ""
      },
      creditCardDetails: {
        number: [],
        expiryMonth: "",
        expiryYear: "",
        name: "",
        cvv: "",
        saveCard: true,
        error: ""
      },
      savedCreditCardDetails: {
        error: ""
      },
      savedCreditCards: [],
      getSeatLayout: 1,
      backURL: "",
      OTPScreen: false,
      walletResponse: {},
      timer: {
        TimeoutModal: false,
        minutes: 14,
        seconds: 59,
        stop: false
      },
      modal: {
        signIn: false,
        guestLogin: false,
        payment: false,
        payUsingWallet: false,
        userTicketsDetails: false
      },
      paymentModal: {
        editContactDetails: false,
        viewContactDetails: true,
        wallet: false
      },
      sectionName: {
        seatLayout: false,
        checkout: false,
        confirmation: false,
        noOfSeats: true,
        typeSelector: false
      },
      seatData: {},
      numberofSeatsArray: [1, 2, 3, 4, 5, 6, 7, 8],
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      totalAmount: 0,
      internetHandling: 10,
      discount: 0,
      movieDetails: {},
      userDetails: {
        email: "",
        phoneNumber: "",
        password: ""
      },
      newPaymentOptions: [],
      signIn: {
        email: "",
        password: "",
        flag: false
      },
      loginErrorMessage: "",
      UserIPAddress: {},
      promoApplied: false,
      reservationID: "",
      bookingID: "",
      SeatTypes: [],
      promoCode: {
        selected: {
          Title: "Select Offer"
        },
        promoList: [],
        errorMessage: "",
        successMessage: "",
        applied: false
      },
      walletInfo: {},
      finalBookingID: "",
      finalBookingDetails: {},
      guest: {
        errorMessage: ""
      },
      Paymentoptions: {
        wallet: {},
        ExpressPay: {},
        creditCard: {}
      },
      nbs: "",
      column: "",
      movieID: "",
      scheduleID: "",
      movieDetails: {},
      seatLayout: [],
      reserveID: "",
      foodAndBeverages: {
        listing: [],
        status: false,
        selected: []
      }
    };
  },
  components: {},
  computed: {
    discountSpace() {},
    finalValue() {
      return (
        parseInt(this.totalAmount) +
        parseInt(this.seatData.ConFee * this.selectedSeats.length) -
        parseInt(this.discount)
      );
    }
  },
  watch: {},

  beforeCreate() {},
  beforeMount() {
    this.backURL =
      "/movie-showtimes-page?movieId=" + this.$route.params.movieID;
    // this.getIPAddress();
    if (TokenService.getToken()) {
      this.signIn.flag = true;
    }
    this.movieID = this.$route.params.movieID;
    this.scheduleID = this.$route.params.scheduleID;
    this.getSeatLayout = this.$route.params.seatLayout;

    this.fetchMovieDetails();
    this.getPromotionList();
    // this.getSeatLayoutDummy();
  },
  mounted: function() {
    // this.getScheduleSeatClasses();
    // this.getPromoCodes();
    EventBus.$on("paymentCompletionEvent", user => {
      this.paymentConfirmation();
    });
    window.addEventListener("message", function(e) {
      if (e.data === "sb:bn:loaded") {
        console.log("eventworking", e);
        EventBus.$emit("paymentCompletionEvent", e);
      }
    });
  },
  methods: {
    // CardonKeyUp: function(item, e) {
    //   console.log('item :', item,this.creditCardDetails.number[item].length);
    //   if (this.creditCardDetails.number[item].length > 4) {
    //     this.creditCardDetails.number[item] = this.creditCardDetails.number[item][this.creditCardDetails.number[item].length];
    //   }
    //   if (e.keyCode < 58 && e.keyCode > 47) {
    //     let value = "card" + (item + 2);
    //     this.$refs[value].focus();
    //   }
    // },
    fetchMovieDetails: function() {
      let token = null;
      let payload = {
        MovieID: this.movieID
      };
      // if (this.$persistStore.get("accessToken")) {
      //   token = this.$persistStore.get("accessToken");
      //   payload["access_token"] = token;
      // }
      console.log("payload", payload);
      makeRequest("/GetShowDetails", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log("data movie", res, error);
          if (!error && res.data) {
            if (!error) {
              this.movieDetails = res.data.Show[0];
              // this.showDetails = res.data.
              // this.movieDetails["url"] =
              //   "/movie-showtimes-page?movieId=" + this.movieDetails.ID;
              // this.movieDetails.IMDBRating = this.movieDetails.IMDBRating.split(
              //   "/"
              // )[0];
              // this.movieDetails.IMDBRating = Math.round(
              //   parseFloat(this.movieDetails.IMDBRating)
              // );
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    confirmNumber: function() {
      console.log("confirm Number", this.getSeatLayout);
      if (this.totalNumberOfSeats < 1) {
        //   vm.$snack.metodo('Please Pick Number of Seats') // Displays a snackbar without action button
        return;
      }
      if (this.getSeatLayout == true) {
        this.sectionName.noOfSeats = false;
        this.sectionName.seatLayout = true;
        this.getSeatLayoutNew();
      } else {
        this.getSeatLayoutNew();
      }
      this.startTimer();
    },
    getSeatLayoutDummy: function() {
      let payload = {
        SchID: this.scheduleID,
        RequiredSeats: 1
      };

      makeRequest("/SNGetSeatLayout", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error) {
            this.cinemaDetails = res.data.Cinema;
            let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            d.setUTCSeconds(this.cinemaDetails.Time);
            this.showDetails.month = d;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getSeatLayoutNew: function() {
      let payload = {
        SchID: this.scheduleID,
        RequiredSeats: this.totalNumberOfSeats
      };

      makeRequest("/GetSeatLayout", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          //   const { data } = res.data;
          console.log("booking seat data", res.data);
          if (!error) {
            this.cinemaDetails = res.data.Cinema;
            this.Default = res.data.Default;
            let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            d.setUTCSeconds(this.cinemaDetails.Time);
            this.showDetails.month = d;

            if (res.data.FNB) {
              this.foodAndBeverages.status = true;
              this.getFoodAndBeverages();
            }
            if (this.getSeatLayout == "1") {
              this.column = res.data.Cinema.Col;
              console.log(" this.column  :", this.column);
              let seatArray = res.data.SeatLayouts;
              this.SeatTypes = res.data.SeatTypes;

              if (seatArray[0].Seats) {
                seatArray.map(x => {
                  x.Seats.map(y => {
                    y.SelectStatus = false;
                    y.SelectStatusFlag = false;
                    return y;
                  });
                  x.Seats = _.chunk(x.Seats, this.column);
                  x.SeatClass = this.SeatTypes;
                  return x;
                });
              }
              this.seatLayout = seatArray;

              // this.seatLayout = res.data.SeatLayouts[0].Seats;
              // this.seatLayout = _.chunk(this.seatLayout, 10);
              // this.seatLayout.map(seatRow => {
              //   seatRow.map(seat => {
              //     seat.SelectStatusFlag = false;
              //     seat.SelectStatus = false;
              //   });
              // });
              // this.SeatTypes = res.data.SeatTypes;
            } else {
              this.selectedSeats = res.data.BookSeatsID;
              this.sectionName.noOfSeats = false;
              this.sectionName.checkout = true;
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    handlerSeatSelected: function(
      seat,
      mainIndex,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e
    ) {
      // console.log('e', e)
      // if(e){ e.preventDefault()}
      //this.events.splice(this.events.indexOf(event), 1);
      // console.log(
      //   "handlerSeatSelected, initial data",
      //   seat,
      //   rowIndex,
      //   seatIndex,
      //   originalIndex
      // );
      // console.log("number of seats", this.totalNumberOfSeats);
      // console.log("seat,rowIndex,seatIndex", seat,rowIndex,seatIndex);
      // console.log("this.seatLayout :", this.seatLayout);
      // console.log('this.seatLayout[mainIndex].Seats[rowIndex][seatIndex] :', this.seatLayout[mainIndex].Seats[rowIndex][seatIndex]);
      seat.seatIndex = seatIndex;
      seat.rowIndex = rowIndex;
      seat.mainIndex = mainIndex;
      // seat.classIndex = classIndex;

      let firstTime = 0;
      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (this.totalNumberOfSeats != this.selectedSeats.length) {
        this.seatLayout[mainIndex].Seats[rowIndex][
          seatIndex
        ].SelectStatusFlag = true;
      }

      if (
        this.seatLayout[mainIndex].Seats[rowIndex][seatIndex]
          .SelectStatusFlag == false
      ) {
        console.log("test19");
        if (this.totalNumberOfSeats != this.selectedSeats.length) {
          console.log("test20");
          this.seatLayout[mainIndex].Seats[rowIndex][
            seatIndex
          ].SelectStatusFlag = true;
        }
      }

      if (
        this.totalNumberOfSeats == this.selectedSeats.length &&
        firstTime == 1
      ) {
        //deselect all
        this.selectedSeats.map(x => {
          this.seatLayout[x.mainIndex].Seats[x.rowIndex][
            x.seatIndex
          ].SelectStatus = false;
          this.seatLayout[x.mainIndex].Seats[x.rowIndex][
            x.seatIndex
          ].SelectStatusFlag = false;
        });
        this.selectedSeats = [];
      }

      if (
        this.seatLayout[mainIndex].Seats[rowIndex][seatIndex].SelectStatus ==
        false
      ) {
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (parseInt(this.totalNumberOfSeats) - this.selectedSeats.length > 0) {
          console.log("2");
          this.seatLayout[mainIndex].Seats[rowIndex][
            seatIndex
          ].SelectStatus = true;
          this.seatLayout[mainIndex].Seats[rowIndex][
            seatIndex
          ].SelectStatusFlag = true;
          this.selectedSeats.push(seat);
          //check on right if available, if yes, select
          console.log(
            "test1",
            this.seatLayout[mainIndex].Seats[rowIndex][parseInt(seatIndex) + 1]
          );
          if (
            this.seatLayout[mainIndex].Seats[rowIndex][
              parseInt(seatIndex) + 1
            ] &&
            backward != "backward" &&
            this.seatLayout[mainIndex].Seats[rowIndex][parseInt(seatIndex) + 1]
              .Status == 1
          ) {
            console.log("3");
            //                        this.selectedSeats.push(seat);
            //                        this.seatData.SeatLayouts[classIndex].Seats[mainIndex].Seats[rowIndex][parseInt(seatIndex) + 1].SelectStatus = true;
            this.handlerSeatSelected(
              this.seatLayout[mainIndex].Seats[rowIndex][
                parseInt(seatIndex) + 1
              ],
              mainIndex,
              rowIndex,
              seatIndex + 1,
              originalIndex
            );

            //check on left if available, if yes, select
          } else if (
            this.seatLayout[mainIndex].Seats[rowIndex][
              parseInt(originalIndex) - 1
            ] &&
            this.seatLayout[mainIndex].Seats[rowIndex][
              parseInt(originalIndex) - 1
            ].Status == 1
          ) {
            console.log("4");
            //                        this.selectedSeats.push(seat);
            //                        this.seatData.SeatLayouts[classIndex].Seats[mainIndex].Seats[rowIndex][parseInt(originalIndex) - 1].SelectStatus = true;
            this.handlerSeatSelected(
              this.seatLayout[mainIndex].Seats[rowIndex][
                parseInt(originalIndex) - 1
              ],
              mainIndex,
              rowIndex,
              originalIndex - 1,
              originalIndex - 1,
              "backward"
            );
          }
        } else {
          console.log("5");
          if (firstTime == 1) {
            this.selectedSeats = [];
            this.handlerSeatSelected(
              this.seatLayout[mainIndex].Seats[rowIndex][parseInt(seatIndex)],
              rowIndex,
              seatIndex
            );
          }
        }
      }

      //compare with total

      //if total > selected

      //check on right if available, if yes, select

      //check on left if available, if yes, select

      //if total == selected

      //if seat selected is selected, do nothing

      // if seat selected is not selected, remove all selected and start again

      //          let isInArray = 0;
      //          this.selectedSeats.map((x, index)=>{
      //              if(x.SeatName == seat.SeatName ){
      //                  this.$delete(this.selectedSeats, index);
      //                  isInArray = 1;
      //              }
      //          });
      //          if(isInArray == 0){
      //              this.selectedSeats.push(seat);
      //          }
      this.totalAmount = 0;
      this.selectedSeats.map((x, index) => {
        this.totalAmount = parseInt(this.totalAmount) + parseInt(x.Price);
      });
      console.log("this.selectedSeats", this.selectedSeats);
    },

    onSeatConfirmaton: function() {
      this.sectionName.checkout = true;
      this.sectionName.seatLayout = false;
      this.totalAmount =
        parseInt(this.totalAmount) + parseInt(this.internetHandling);
      const token2 = TokenService.getToken();
      if (token2) {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: false
        };
        this.getUserDetails();
      } else {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: true
        };
      }
      //          this.dropDownFunction();
      this.bookingRequestConfirmSeats();
    },
    bookingRequestConfirmSeats: function() {
      let payload = {
        SchID: this.scheduleID,
        SelectedSeats: this.selectedSeats
      };
      makeRequest("/BookingReserve", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.reserveID = res.data.ReserveID;
            this.getPaymentOptions();
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getFoodAndBeverages: function() {
      let payload = {
        SchID: 5 || this.scheduleID
      };
      makeRequest("/GetFnBItems/", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.foodAndBeverages.Listing = res.data.ReserveID;
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    bookFoodAndBeverages: function() {
      let payload = {
        ReserveID: this.reserveID,
        FNB: this.foodAndBeverages.selected
      };
      makeRequest("/BookingFNBItem", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    submitUserDetails: function() {
      let payload = {
        ReserveID: this.reserveID,
        Email: userDetails.email,
        Mobile: userDetails.phoneNumber,
        CountryCode: userDetails.countryCode
      };
      makeRequest("/BookingFNBItem", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getPaymentOptions: function() {
      let payload = {
        ReserveID: this.reserveID
      };
      makeRequest("/GetPaymentOptions/", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
            //   console.log(" pay Options res ", res);
            // console.log(" pay Options Data ", res.data);
            res.data.Paymentoptions.forEach(singlePaymentOption => {
              if (singlePaymentOption.PaymentID == 3) {
                singlePaymentOption.Cards = singlePaymentOption.Cards.forEach(
                  x => {
                    x["CVV"] = "";
                    this.savedCreditCards.push(x);
                  }
                );
                //   this.savedCreditCards = singlePaymentOption.Cards;
                // console.log('test1', this.savedCreditCards,singlePaymentOption.Cards )
              }
            });
            // this.savedCreditCards = res.data.Paymentoptions[1];
            this.newPaymentOptions = res.data.Paymentoptions;

            // this.paymentOptions = data.paymentOptions.Paymentoptions;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    verifyPromotion: function() {
      let payload = {
        ReserveID: this.reserveID,
        PromotionID: this.promotion.selected
      };
      makeRequest("/VerifyPromotion", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    processPayment: function() {
      // let payload = {
      //   ReserveID: this.reserveID,
      //   PaymentID: 1
      // };
      // if (this.promotion.selected) {
      //   payload.PromotionID = this.promotion.selected;
      // }
      const token2 = TokenService.getToken();

      let payload = {
        ReserveID: this.reserveID,
        PaymentID: 1,
        PromotionID: 0
      };
      makeRequest("/ProcessPayment", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    confirmBooking: function() {
      let payload = {
        ReserveID: this.reserveID,
        PaymentID: 1,
        LanguageID: 2,
        CountryID: 230,
        OTP: this.OTP
      };
      //if token send token else empty
      makeRequest("/ConfirmBooking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
            this.finalBookingID = res.data.BookingID;
            this.getBookingDetails();
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getBookingDetails: function() {
      let payload = {
        BookingID: this.finalBookingID
      };

      makeRequest("/GetBookingDetails", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("booking fetch final Confirmation", res.data);
          if (!error) {
            this.finalBookingDetails = res.data.DataObject;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    selectPromoFromList: function(promo, e) {
      e.preventDefault();
      if (this.promoCode.selected.Title == "Reset Offer") {
        this.promoCode.selected = {
          Title: "Select Offer"
        };
        return;
      } else {
        this.promoCode.selected = promo;
      }
    },
    restartBooking: function(e) {
      e.preventDefault();
      let movieId = this.$route.query.movieID;
      let scheduleId = this.$route.query.scheduleID;
      let seatLayout = this.$route.query.seatLayout;
      window.location = `/checkout/${scheduleId}/${movieId}/${seatLayout}`;
    },
    payUsingWallet: function() {
      let token = this.$persistStore.get("accessToken");
      let payload = {
        access_token: token,
        usertranstion: {
          Amount:
            this.totalAmount +
            this.seatData.ConFee * this.selectedSeats.length -
            this.discount,
          Narration: "Booked ticket for The Godfather",
          OrderId: this.bookingID,
          PaymentType: 3,
          TransType: 0,
          UserId: "105"
        }
      };
      makeRequestDirect("/cinematic/DebitTransation", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("payment request", res.data);
          if (!error) {
            this.walletResponse = res.data;
            this.OTPScreen = true;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    makeSavedCardPayment: function(cardID, CVV, $event) {
      console.log("cardID", cardID);
      $event.preventDefault();
      let token = this.$persistStore.get("accessToken");
      console.log("cardID", cardID);
      let payload = {
        PaymentID: "3",
        access_token: token,
        bookingOrderId: this.bookingID,
        cardDetails: {
          CVV: CVV,
          CardID: cardID
        }
      };
      makeRequestDirect("/cinematic/BookingOrderConfirm", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("payment request", res.data);
          if (!error) {
            console.log("otp page");
            if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
              this.savedCreditCardDetails.error = res.data.ErrDesc.ErrorMessage;
            } else {
              this.savedBankPage.src = res.data.ErrDesc._links.acsUrl;
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    validateBeforeSubmit(scope) {
      console.log("scope :", scope);
      if (scope == "cardDetails") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.makeCardPayment();
            return;
          }
        });
      } else if (scope == "bookUser") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            let payload = {
              Email: this.userDetails.email,
              Mobile: this.userDetails.phoneNumber,
              ReserveID: this.reserveID,
              CountryCode: this.Default.CountryCode
            };
            makeRequest("/UpdateBookUser", "POST", null, payload)
              .then(response => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.modal.userTicketsDetails = true;
                  this.modal.payment = true;
                } else {
                  this.modal.signIn = false;
                  this.modal.userTicketsDetails = true;
                  this.modal.payment = true;
                }
              })
              .catch(error => {
                console.log("Error", error);
              });
            return;
          }
        });
      }
    },

    makeCardPayment: function() {
      let token = TokenService.getToken();
      let payload = {
        PaymentID: "2",
        access_token: token,
        bookingOrderId: this.bookingID,
        cardDetails: {
          cardNumber: this.creditCardDetails.number
            .toString()
            .replace(/,/g, ""),
          expiryMonth: this.creditCardDetails.expiryMonth,
          expiryYear: this.creditCardDetails.expiryYear,
          CVV: this.creditCardDetails.cvv,
          cardNameHolder: this.creditCardDetails.name,
          saveCard: "1"
        }
      };
      if (!this.creditCardDetails.saveCard) {
        payload.cardDetails.saveCard = "0";
      }
      makeRequest("/cinematic/BookingOrderConfirm", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("payment request", res.data);
          if (!error) {
            console.log("otp page");
            if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
              this.creditCardDetails.error = res.data.ErrDesc.ErrorMessage;
            } else {
              this.bankPage.src = res.data.ErrDesc._links.acsUrl;
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    bookingOrderConfirm: function() {
      let token = this.$persistStore.get("accessToken");
      let payload = {
        OTP: "1234",
        PaymentID: "1",
        access_token: token,
        bookingOrderId: this.bookingID
      };

      makeRequestDirect("/cinematic/BookingOrderConfirm", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("booking OTP Confirmation", res.data);
          if (!error) {
            this.sectionName = {
              seatLayout: false,
              checkout: false,
              confirmation: true,
              noOfSeats: false,
              typeSelector: false
            };
            this.finalBookingID = res.data.BookingOrderId;
            this.getBookingDetails();
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    // editContactDetailsToggle: function(e) {
    //   if (e) e.preventDefault();
    //   this.paymentModal.editContactDetails = !this.paymentModal
    //     .editContactDetails;
    //   this.paymentModal.viewContactDetails = !this.paymentModal
    //     .viewContactDetails;
    // },
    submitContactDetails: function(e) {
      e.preventDefault();
      //TODO Submit New Contact Details

      this.editContactDetailsToggle();
    },
    startTimer: function() {
      setInterval(() => {
        if (this.timer.stop == true) {
          return;
        }
        if (parseInt(this.timer.seconds) == 0) {
          this.timer.seconds = 60;
        }
        this.timer.seconds = parseInt(this.timer.seconds) - 1;
        if (this.timer.seconds < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }
      }, 1000);
      setInterval(() => {
        if (this.timer.stop == true) {
          return;
        }
        if (this.timer.minutes == 0) {
          //TODO Show timeout message and a redirect button
          this.timer.TimeoutModal = true;
          this.timer.minutes = 0;
          this.timer.seconds = 0;
          this.timer.stop = true;
        }
        this.timer.minutes = parseInt(this.timer.minutes) - 1;
      }, 60000);
    },
    userSigninModalBack: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    getIPAddress: function() {
      makeRequest("/GetCountryList", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          const { data } = res.data;
          this.UserIPAddress = res.data.Default.IPAddress;
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    editNumberOfSeats: function(number) {
      this.totalNumberOfSeats = number;
    },
    showUserLogInModal: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    showGuestModal: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: false,
        guestLogin: true,
        payment: false
      };
    },
    checkOutAsGuest: function() {
      //Save Details to user Details
      //check values of details
      if (this.userDetails && this.phoneNumber) {
        this.insertBookingOrderUserDetails();
        this.sectionName.checkout = true;
        this.modal.payment = true;
        modal.guestLogin = false;
      } else {
        this.guest.errorMessage = "Please enter a valid email and Phone Number";
      }

      //show payment details
    },
    getUserDetails: function(callback) {
      let payload = {};
      makeRequest("/GetProfile", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
            console.log("get User Details Data on my account  >>", res.data);
            // userDetails
            this.userDetails.email = res.data.Email;
            this.userDetails.phoneNumber = res.data.MobileNo;
            this.userDetails.userName = res.data.UserName;
            //   this.userDetails.phoneNumber = data.userDetails.MobileNo.replace(
            //       /\D/g,
            //       ""
            //   );
            if (callback) {
              callback();
            }
            //   this.userDetails.profilePic =
            //       data.userDetails.ProfileURl.length > 0
            //           ? data.userDetails.ProfileURl
            //           : "/images/svg/icon-profile.svg";
            //   this.loginData.loginInput.email = data.userDetails.Email;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    onConfirmSubmit: function() {
      // this.getReserveSeatsDetails,
      //   this.getSeatIds
      let payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      makeRequest("/api/reserve-booking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.status) {
            console.log(" Reserve Seats Data ", data);
            if (data.reserveBooking.Status) {
              secureStore.set("GSRID", data.reserveBooking.ReserveID);
              this.$router.replace({
                path: "/seat-payment-mode",
                params: {}
              });
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getPromotionList: function() {
      makeRequest("/GetPromotionList", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.promoCode.promoList = res.data.Promotions;
            // this.promoCode.promoList.push({
            //   Title: "Reset Offer"
            // });
          }
        })
        .catch(error => {
          console.log("Error ", error);
        });
    },
    verifyPromoCode: function(e, type) {
      e.preventDefault();
      //   console.log("Here testing", this.promoCode.input);

      if (type == "bankOffer") {
        let payload = {
          OfferID: this.promoCode.selected.ID,
          CardNumber: this.creditCardDetails.number
        };
        makeRequestDirect("/api/Payment/VerifyCoupon/", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            const { data } = res.data;
            console.log("Checking Verify Coupon result >", res.data);
            if (!error && res.data.Status) {
              this.discount = res.data.DiscountValue;
              this.promoCode.button = true;
              this.promoCode.errorMessage = "";
              this.promoCode.successMessage = res.data.Message;
            } else {
              this.discount = 0;
              this.promoCode.errorMessage = res.data.Message;
              this.promoCode.successMessage = "";
            }
          })
          .catch(error => {
            console.log("Error ", error);
          });
      } else {
        let payload = {
          CouponCode: this.promoCode.input,
          Total: this.totalAmount
        };
        makeRequestDirect("/api/Payment/VerifyCoupon/", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            const { data } = res.data;
            console.log("Checking Verify Coupon result >", res.data);
            if (!error && res.data.Status) {
              this.discount = res.data.DiscountValue;
              this.promoCode.button = true;
              this.promoCode.errorMessage = "";
              this.promoCode.successMessage = res.data.Message;
            } else {
              this.discount = 0;
              this.promoCode.errorMessage = res.data.Message;
              this.promoCode.successMessage = "";
            }
          })
          .catch(error => {
            console.log("Error ", error);
          });
      }
    },

    getWallet: function() {
      // console.log("Here Wallet  >>", payment);
      let payload = {
        reserveId: this.reserveBookingId
      };

      makeRequestDirect("/cinematic/GetUserWallet", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("check-wallet Result ", res);
          if (!error && res.data.status && res.data.data.checkWallet.Status) {
            this.status.enableOtpFlag = true;
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    paymentConfirmation: function(e) {
      //   e.preventDefault();
      this.bankPage.src = "";
      this.savedBankPage.src = "";
      this.sectionName.confirmation = true;
      this.sectionName.checkout = false;
      //BookAPI
      this.getBookingDetails();
      //TODO Fetch final BookingID
    },
    userLogIn: function(e) {
      e.preventDefault();
      makeRequest("/api/signin", "POST", null, {
        Password: this.userDetails.password,
        UserName: this.userDetails.email
      })
        .then(response => {
          const { error, res } = response;

          const { data } = res.data;
          console.log(res, "<<< Sign Im Data >>>", data);
          if (!error && res.data.status && data.result.Status) {
            // Handle Sign In
            this.$persistStore.set("accessToken", data.result.access_token);
            this.signIn.flag = true;
            this.modal.signIn = false;
            this.sectionName.checkout = true;
            EventBus.$emit("LoginUser", {
              status: true,
              userName: "test1"
            });
            this.modal.payment = true;
            // this.getUserDetails(() => {
            //   this.insertBookingOrderUserDetails();
            // });
          } else if (!data.result.Status) {
            this.loginErrorMessage = data.result.Message;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    handlerSeatSelectedold1: function(
      seat,
      classIndex,
      rowIndex,
      seatIndex,
      originalIndex,
      backward
    ) {
      //this.events.splice(this.events.indexOf(event), 1);
      console.log("test", seat, classIndex, rowIndex, seatIndex, originalIndex);
      console.log("number of seats", this.totalNumberOfSeats);
      console.log("seat Selected", seat);
      seat.seatIndex = seatIndex;
      seat.rowIndex = rowIndex;
      seat.classIndex = classIndex;

      let firstTime = 0;
      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (this.totalNumberOfSeats != this.selectedSeats.length) {
        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
          parseInt(seatIndex)
        ].SelectStatusFlag = true;
      }
      if (
        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
          parseInt(seatIndex)
        ].SelectStatusFlag == false
      ) {
        if (this.totalNumberOfSeats != this.selectedSeats.length) {
          this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
            parseInt(seatIndex)
          ].SelectStatusFlag = true;
        }
      }

      if (
        this.totalNumberOfSeats == this.selectedSeats.length &&
        firstTime == 1
      ) {
        //deselect all
        this.selectedSeats.map(x => {
          this.seatData.SeatLayouts[x.classIndex].Seats[x.rowIndex][
            x.seatIndex
          ].SelectStatus = false;
          this.seatData.SeatLayouts[x.classIndex].Seats[x.rowIndex][
            x.seatIndex
          ].SelectStatusFlag = false;
        });
      }

      console.log("ft", firstTime);
      console.log(
        "Seat Selected",
        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
          parseInt(seatIndex)
        ]
      );
      if (
        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
          parseInt(seatIndex)
        ].SelectStatus == false
      ) {
        console.log("1");
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (this.totalNumberOfSeats - this.selectedSeats.length > 0) {
          console.log("2");
          this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
            parseInt(seatIndex)
          ].SelectStatus = true;
          this.selectedSeats.push(seat);
          //check on right if available, if yes, select
          console.log(
            "test1",
            this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
              parseInt(seatIndex) + 1
            ]
          );
          if (
            this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
              parseInt(seatIndex) + 1
            ] &&
            backward != "backward"
          ) {
            console.log("3");
            //                        this.selectedSeats.push(seat);
            //                        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(seatIndex) + 1].SelectStatus = true;
            this.handlerSeatSelected(
              this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
                parseInt(seatIndex) + 1
              ],
              classIndex,
              rowIndex,
              seatIndex + 1,
              originalIndex
            );

            //check on left if available, if yes, select
          } else if (
            this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
              parseInt(originalIndex) - 1
            ]
          ) {
            console.log("4");
            //                        this.selectedSeats.push(seat);
            //                        this.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(originalIndex) - 1].SelectStatus = true;
            this.handlerSeatSelected(
              this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
                parseInt(originalIndex) - 1
              ],
              classIndex,
              rowIndex,
              originalIndex - 1,
              originalIndex - 1,
              "backward"
            );
          }
        } else {
          console.log("5");
          if (firstTime == 1) {
            this.selectedSeats = [];
            this.handlerSeatSelected(
              this.seatData.SeatLayouts[classIndex].Seats[rowIndex][
                parseInt(seatIndex)
              ],
              classIndex,
              rowIndex,
              seatIndex
            );
          }
        }
      }
      this.totalAmount = 0;
      this.selectedSeats.map((x, index) => {
        this.totalAmount = parseInt(this.totalAmount) + parseInt(x.Price);
      });
    },
    reserveSeatsSelected: function() {
      let payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      makeRequest("/api/reserve-booking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.status) {
            console.log(" Reserve Seats Data ", data);
            if (data.reserveBooking.Status) {
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    }
  }
};
</script>

<style>
footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/checkout.vue